"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PayAccountLayout = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _payAccountLayoutModule = _interopRequireDefault(require("./pay-account-layout.module.scss"));
var _noop = require("../../utils/noop");
var _classnames = _interopRequireDefault(require("classnames"));
var _useTranslation2 = require("../../hooks/useTranslation/useTranslation");
var _selectComponents = require("../../components/select-components");
var _excluded = ["selectedAccountId", "onAccountChange", "accounts", "isLoading", "className", "containerClassName", "accountBalances", "addFundsButton"];
var PayAccountLayout = function PayAccountLayout(_ref) {
  var selectedAccountId = _ref.selectedAccountId,
    _ref$onAccountChange = _ref.onAccountChange,
    onAccountChange = _ref$onAccountChange === void 0 ? _noop.noop : _ref$onAccountChange,
    _ref$accounts = _ref.accounts,
    accounts = _ref$accounts === void 0 ? [] : _ref$accounts,
    isLoading = _ref.isLoading,
    className = _ref.className,
    containerClassName = _ref.containerClassName,
    accountBalances = _ref.accountBalances,
    addFundsButton = _ref.addFundsButton,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement("div", Object.assign({
    className: (0, _classnames.default)(_payAccountLayoutModule.default['pay-account'], className)
  }, rest), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_payAccountLayoutModule.default['pay-account__container'], containerClassName)
  }, /*#__PURE__*/_react.default.createElement(_selectComponents.SearchSelect, {
    id: "pay-account",
    "data-testid": "pay-account",
    onChange: function onChange(e) {
      return onAccountChange(e.currentTarget.value);
    },
    name: "pay-account",
    options: accounts,
    value: selectedAccountId,
    disabled: accounts.length <= 1 || !selectedAccountId || isLoading,
    clearable: false,
    placeholder: isLoading ? t('payAccountlayout.loading') : t('payAccountlayout.select'),
    className: _payAccountLayoutModule.default['pay-account__select']
  }), accountBalances, addFundsButton));
};
exports.PayAccountLayout = PayAccountLayout;